export default function useAdyen() {
  const { jsBaseUrl, cssBaseUrl, jsIntegrity, cssIntegrity } = useFeatureFlags().configAdyen
  const countryCode = useCountryCode()
  const api = useApi()

  useHead({
    link: () => [
      {
        rel: 'stylesheet',
        type: 'text/css',
        href: cssBaseUrl,
        integrity: cssIntegrity,
        crossorigin: 'anonymous'
      }
    ]
  })

  const { load } = useScript(
    {
      src: jsBaseUrl,
      integrity: jsIntegrity,
      crossorigin: 'anonymous'
    },
    { trigger: 'manual' }
  )

  const loadPaymentProvider = (paymentMethod: 'paypal' | 'googlepay') => async (onError?: (error: Error) => void) => {
    try {
      await load()

      const session = await api.cart.$getPaymentSession({
        referer: window.location.origin,
        paymentMethodId: 'CREDIT_CARD',
        paymentMethod
      }, {
        retryDelay: 3000,
        headers: { 'content-type': 'application/json' }
      })

      if (!session.success || !session.meta || !session.locale)
        throw session

      return await window.AdyenWeb.AdyenCheckout({
        locale: session.locale,
        countryCode,
        environment: session.meta?.environment,
        clientKey: session.meta?.clientKey
      })
    }
    catch (error: any) {
      log.error('Get payment session error', error)
      onError?.(error)
    }
  }

  return {
    loadGooglePay: loadPaymentProvider('googlepay'),
    loadPaypal: loadPaymentProvider('paypal')
  }
}
